import { Checkbox, Col, DatePicker, Divider, Row, Space } from "antd";
import { DateOnlyFormat } from "models/websiteSettings";
import moment from "moment";
import { FC, MouseEvent, useState } from "react";
import BulkActionModal, { BulkActionModalProps } from "../CardTitleQA/BulkActionModal";

const ChangeUploadDateModal: FC<BulkActionModalProps & {
    onConfirm: (uploadDate: string | null) => Promise<void>
}> = ({ affectedCount, open, onCancel, onConfirm }) => {
    const [uploadDate, setUploadDate] = useState<string | undefined>();
    const [usePackageDate, setUsePackageDate] = useState<boolean>(false);

    const reset = () => {
        setUploadDate(undefined);
        setUsePackageDate(false);
    }

    const confirm = async () => {
        await onConfirm(uploadDate ?? null);
        reset();
    }

    const cancel = (e: MouseEvent<HTMLElement>) => {
        if (onCancel) {
            onCancel(e);
        }
        reset();
    }

    return <BulkActionModal
        title="Change Upload Date"
        affectedCount={affectedCount}
        open={open}
        onOk={confirm}
        onCancel={cancel}
        allowConfirm={!!uploadDate || usePackageDate}
    >
        <Row>
            <Col span={21} offset={3}>
                <Space direction="vertical">
                    <Space>
                        <div>Select New Upload Date:</div>
                        <DatePicker
                            disabled={usePackageDate}
                            format="MM/DD/YYYY"
                            disabledDate={(date: moment.Moment) => date.isBefore(moment().subtract(1, 'days'))}
                            onChange={(date) => setUploadDate(date?.format(DateOnlyFormat) ?? undefined)}
                        />
                    </Space>
                    <Divider>- or -</Divider>
                    <Space>
                        <Checkbox
                            disabled={!!uploadDate}
                            checked={usePackageDate}
                            onChange={e => setUsePackageDate(e.target.checked)}
                        >
                            Use Individual Package Estimated Upload Date
                        </Checkbox>
                    </Space>
                </Space>
            </Col>
        </Row>
    </BulkActionModal>;
};

export default ChangeUploadDateModal;